import Http from './axios';

let api = {
    get: (url, params, success, error) => {
        return Http.get(url, { params: params }).then(success).catch(error);
    },
    post: (url, params, success, error) => {
        return Http.post(url, params).then(success).catch(error);
    },
    http: {
        get: (url, param) => {
            return Http.get(url, { params: param }).catch(function (err) { });
        },
        post: (url, param) => {
            return Http.post(url, param).catch(function (err) { });
        }
    },
    //管理页面
    management: {
        getTreeList: param => {
            return Http.get('management/tree', { params: param }).catch(function (err) { })
        },
        getAdvertiserList: param => {
            return Http.get('management/getAdvertiserList', { params: param }).catch(function (err) { })
        },
        userStatus: param => {
            return Http.post('management/userStatus', param).catch(function (err) { })
        },
        userGroups: param => {
            return Http.get('management/userGroups', { params: param }).catch(function (err) { })
        },
        getUserGroups: param => {
            return Http.get('management/getUserGroups', { params: param }).catch(function (err) { })
        },
        getCustomer: param => {
            return Http.get('management/getCustomer', { params: param }).catch(function (err) { })
        },
        getCustomerInt: param => {
            return Http.get('management/getCustomerInt', { params: param }).catch(function (err) { })
        },
        getCustomerAdd: param => {
            return Http.post('management/getCustomerAdd', param).catch(function (err) { })
        },
        getGroupsAdd: param => {
            return Http.post('management/getGroupsAdd', param).catch(function (err) { })
        },
        userAdd: param => {
            return Http.post('management/userAdd', param).catch(function (err) { })
        },
        userEditGet: param => {
            return Http.get('management/userEditGet', { params: param }).catch(function (err) { })
        },
        userEdit: param => {
            return Http.post('management/userEdit', param).catch(function (err) { })
        },
        userDelete: param => {
            return Http.post('management/userDelete', param).catch(function (err) { })
        },
        updateMenus: param => {
            return Http.get('management/updateMenus', { params: param }).catch(function (err) { })
        },
        updateActions: param => {
            return Http.get('management/updateActions', { params: param }).catch(function (err) { })
        },
        //角色管理
        roleList: param => {
            return Http.get('management/roleList', { params: param }).catch(function (err) { })
        },
        roleAdd: param => {
            return Http.post('management/roleAdd', param).catch(function (err) { })
        },
        roleGet: param => {
            return Http.get('management/roleGet', { params: param }).catch(function (err) { })
        },
        roleEdit: param => {
            return Http.post('management/roleEdit', param).catch(function (err) { })
        },
        roleMenus: param => {
            return Http.get('management/roleMenus', { params: param }).catch(function (err) { })
        },
        roleMenusAdd: param => {
            return Http.post('management/roleMenusAdd', param).catch(function (err) { })
        },
        roleActions: param => {
            return Http.get('management/roleActions', { params: param }).catch(function (err) { })
        },
        roleActionsAdd: param => {
            return Http.post('management/roleActionsAdd', param).catch(function (err) { })
        },
        roleActionsDel: param => {
            return Http.get('management/roleDelete', { params: param }).catch(function (err) { })
        },
        //菜单管理
        menuList: param => {
            return Http.get('management/menuList', { params: param }).catch(function (err) { })
        },



    },
    //推广管理
    adPromotion: {
        //账户管理
        addProject: param => {
            return Http.post('adPromotion/addProject', param).catch(function (err) { });
        },
        handleTableAccount: param => {
            return Http.post('adPromotion/handleTableAccount', param).catch(function (err) { });
        },
        allAction: param => {
            return Http.post('adPromotion/allAction', param).catch(function (err) { });
        },
        clickRelevance: param => {
            return Http.post('adPromotion/clickRelevance', param).catch(function (err) { });
        },
        addTask: param => {
            return Http.post('adPromotion/addTask', param).catch(function (err) { });
        },
        getProjectLists: param => {
            return Http.get('adPromotion/getProjectLists', { params: param }).catch(function (err) { });
        },
        updateCustomer: param => {
            return Http.get('adPromotion/updateCustomer', { params: param }).catch(function (err) { });
        },
        getAccountData: param => {
            return Http.get('adPromotion/getAccountData', { params: param }).catch(function (err) { });
        },
        getTaskList: param => {
            return Http.get('adPromotion/getTaskList', { params: param }).catch(function (err) { });
        },
        getUserInfo: param => {
            return Http.get('adPromotion/getUserInfo', { params: param }).catch(function (err) { });
        },
        actionUrl: param => {
            return Http.get('adPromotion/actionUrl', { params: param }).catch(function (err) { });
        },
		getAgentId: param => {
            return Http.post('pyadver/agentlist', param).catch(function (err) { });
        },
		addAgentTask: param => {
		    return Http.post('pyadver/addcopytask', param).catch(function (err) { });
		},
		getCopyTasklist: param => {
		    return Http.post('pyadver/copytasklist', param).catch(function (err) { });
		},
        //广告投放
        saveTemplate: param => {//index_v1_index_CampaignTemplate_createTemplate
            return Http.post('adPromotion/saveTemplate', param).catch(function (err) { });
        },
        saveTagInfo: param => {//index_v1_index_Tag_createTagBag
            return Http.post('adPromotion/saveTagInfo', param).catch(function (err) { });
        },
        actionAdver: param => {//index_v1_index_AdCreate_addCreateAdTask
            return Http.post('adPromotion/actionAdver', param).catch(function (err) { });
        },
        addTags: param => {//index_v1_index_TitleBag_createTitleBag
            return Http.post('adPromotion/addTags', param).catch(function (err) { });
        },
        getSourceList: param => {//index_v1_index_source_getSourceInfo
            return Http.get('adPromotion/getSourceList', { params: param }).catch(function (err) { });
        },
        getWordsInfo: param => {//index_v1_index_adCreate_getWordsInfo
            return Http.get('adPromotion/getWordsInfo', { params: param }).catch(function (err) { });
        },
        getTitleList: param => {//index_v1_index_TitleBag_getList
            return Http.get('adPromotion/getTitleList', { params: param }).catch(function (err) { });
        },
        getTagsInfo: param => {//index_v1_index_Tag_getList
            return Http.get('adPromotion/getTagsInfo', { params: param }).catch(function (err) { });
        },
        getInterestCategories: param => {//index_v1_index_adCreate_getInterestCategories
            return Http.get('adPromotion/getInterestCategories', { params: param }).catch(function (err) { });
        },
        getInterestWords: param => {//index_v1_index_adCreate_getInterestWords
            return Http.get('adPromotion/getInterestWords', { params: param }).catch(function (err) { });
        },
        getActionWords: param => {//index_v1_index_adCreate_getActionWords
            return Http.get('adPromotion/getActionWords', { params: param }).catch(function (err) { });
        },
        getActionScene: param => {//index_v1_index_adCreate_getActionSceneInfo
            return Http.get('adPromotion/getActionScene', { params: param }).catch(function (err) { });
        },
        getCategoriesInfo: param => {//index_v1_index_adCreate_getCategoriesInfo
            return Http.get('adPromotion/getCategoriesInfo', { params: param }).catch(function (err) { });
        },
        getAccountsInfo: param => {//index_v1_index_adCreate_getAccountsInfo
            return Http.get('adPromotion/getAccountsInfo', { params: param }).catch(function (err) { });
        },
        getRetargetingInfo: param => {//index_v1_index_adCreate_getRetargetingInfo
            return Http.get('adPromotion/getRetargetingInfo', { params: param }).catch(function (err) { });
        },
        getCityJson: param => {//index_v1_index_adCreate_getCityJson
            return Http.get('adPromotion/getCityJson', { params: param }).catch(function (err) { });
        },
        addTargeting: param => {//home_v1_adver_targetingAdd
            return Http.get('adPromotion/addTargeting', { params: param }).catch(function (err) { });
        },
        editTargeting: param => {//home_v1_adver_targetingSave
            return Http.get('adPromotion/editTargeting', { params: param }).catch(function (err) { });
        },
        deleteTargeting: param => {//home_v1_adver_targetingDel
            return Http.get('adPromotion/deleteTargeting', { params: param }).catch(function (err) { });
        },
        getTargetingInfo: param => {//home_v1_adver_targetingList
            return Http.get('adPromotion/getTargetingInfo', { params: param }).catch(function (err) { });
        },
        getIndustry: param => {//index_v1_index_adCreate_getIndustrys
            return Http.get('adPromotion/getIndustry', { params: param }).catch(function (err) { });
        },
        saveProduct: param => {//index_v1_index_adCreate_getProductImgId
            return Http.get('adPromotion/saveProduct', { params: param }).catch(function (err) { });
        },
        getAdvertiserInfo: param => {//index_v1_index_adCreate_getAdverList
            return Http.get('adPromotion/getAdvertiserInfo', { params: param }).catch(function (err) { });
        },
        getProductInfo: param => {//index_v1_index_adCreate_getProductList
            return Http.get('adPromotion/getProductInfo', { params: param }).catch(function (err) { });
        },
        getDouyingInfo: param => {//index_v1_index_adCreate_getDouyingList
            return Http.get('adPromotion/getDouyingInfo', { params: param }).catch(function (err) { });
        },
        remoteMethodTemplate: param => {//index_v1_index_CampaignTemplate_getList
            return Http.get('adPromotion/remoteMethodTemplate', { params: param }).catch(function (err) { });
        },



    },
    //资产管理
    assets: {
        getGroupList: param => {
            return Http.get('assets/getGroupList', { params: param }).catch(function (err) { });
        },
        getSourceList: param => {
            return Http.get('assets/getSourceList', { params: param }).catch(function (err) { });
        },
        getGroupTree: param => {
            return Http.get('assets/getGroupTree', { params: param }).catch(function (err) { });
        },
        addGroup: param => {
            return Http.post('assets/addGroup', param).catch(function (err) { });
        },
        getGroup: param => {
            return Http.get('assets/getGroup', { params: param }).catch(function (err) { });
        },
        modifyGroup: param => {
            return Http.post('assets/modifyGroup', param).catch(function (err) { });
        },
        delGroup: param => {
            return Http.get('assets/delGroup', { params: param }).catch(function (err) { });
        },
        delSource: param => {
            return Http.get('assets/delSource', { params: param }).catch(function (err) { });
        },
        getSourceDetail: param => {
            return Http.get('assets/getSourceDetail', { params: param }).catch(function (err) { });
        },
        delFile: param => {
            return Http.get('assets/delFile', { params: param }).catch(function (err) { });
        },
        getSub: param => {
            return Http.get('assets/getSub', { params: param }).catch(function (err) { });
        },
        addSource: param => {
            return Http.post('assets/addSource', param).catch(function (err) { });
        },
        modifySource: param => {
            return Http.post('assets/modifySource', param).catch(function (err) { });
        },
        delTemplate: param => {
            return Http.get('assets/delTemplate', { params: param }).catch(function (err) { });
        },
        titleBagGetOneInfo: param => {
            return Http.get('assets/getTitleBagOneInfo', { params: param }).catch(function (err) { });
        },
        titleBagAddTitles: param => {
            return Http.post('assets/addTitles', param).catch(function (err) { });
        },
        titleBagEditTitles: param => {
            return Http.post('assets/editTitles', param).catch(function (err) { });
        },
        titleBagDelTitle: param => {
            return Http.get('assets/delTitle', { params: param }).catch(function (err) { });
        },
        projectList: param => {
            return Http.get('assets/projectList', { params: param }).catch(function (err) { });
        },
        CampaignTemplateGetList: param => {
            return Http.get('assets/getCampaignTemplateList', { params: param }).catch(function (err) { });
        },
        TitleBagGetList: param => {
            return Http.get('assets/getTitleBagList', { params: param }).catch(function (err) { });
        },
        TagGetList: param => {
            return Http.get('assets/getTagList', { params: param }).catch(function (err) { });
        },
        tagGetOneInfo: param => {
            return Http.get('assets/getTagOneInfo', { params: param }).catch(function (err) { });
        },
        delTagFromBag: param => {
            return Http.get('assets/delTagFromBag', { params: param }).catch(function (err) { });
        },
        editTags: param => {
            return Http.post('assets/editTags', param).catch(function (err) { });
        },
        addTags: param => {
            return Http.post('assets/addTags', param).catch(function (err) { });
        },
        getTagsInfo: param => {
            return Http.get('assets/getTagsInfo', { params: param }).catch(function (err) { });
        },
        getTitleInfo: param => {
            return Http.get('assets/getTitleInfo', { params: param }).catch(function (err) { });
        },
        getTemplateInfo: param => {
            return Http.get('assets/getTemplateInfo', { params: param }).catch(function (err) { });
        }
    }



}
export default {
    install: Vue => {
        Vue.api = api,
            Vue.prototype.$api = api
    }
}